import React from 'react';
import { Card, VStack, Box, Text, Stack, Separator, Skeleton } from '@chakra-ui/react';
import Avatar from 'boring-avatars';

interface ProfileCardData {
  userName: string;
  accountId: string;
  transactionCount: number;
  registeredAt: string;
}

interface ProfileCardProps {
  data?: ProfileCardData;
  isLoading?: boolean;
}

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const year = date.getFullYear() % 100; // 年を下2桁に
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${day
    .toString()
    .padStart(2, '0')}`;
};

const ProfileCard: React.FC<ProfileCardProps> = ({ data, isLoading }) => (
  <Card.Root w="full" variant="elevated" bg="white/80" borderRadius="2xl">
    <Card.Body py={4}>
      <VStack gap={3}>
        <Box borderRadius="full" overflow="hidden">
          {isLoading ? (
            <Skeleton width="64px" height="64px" borderRadius="full" />
          ) : data ? (
            <Avatar
              size={64}
              name={data.userName}
              variant="beam"
              colors={['#0a0310', '#49007e', '#ff005b', '#ff7d10', '#ffb238']}
            />
          ) : null}
        </Box>
        <VStack gap={0.5}>
          {isLoading ? (
            <>
              <Skeleton height="24px" width="120px" />
              <Skeleton height="16px" width="80px" />
            </>
          ) : data ? (
            <>
              <Text fontSize="lg" fontWeight="bold" color="gray.800">
                {data.userName}
              </Text>
              <Text fontSize="sm" color="gray.600">
                @{data.accountId}
              </Text>
            </>
          ) : (
            <Text fontSize="sm" color="gray.600">
              プロフィール情報を取得できませんでした
            </Text>
          )}
        </VStack>
        <Stack w="full" direction="row" gap={3} justify="center" mt={1}>
          <VStack gap={0.5}>
            {isLoading ? (
              <Skeleton height="28px" width="60px" />
            ) : data ? (
              <Text fontSize="xl" fontWeight="bold" color="teal.600">
                {data.transactionCount}
              </Text>
            ) : null}
            <Text fontSize="2xs" color="gray.600">
              取引回数
            </Text>
          </VStack>
          <Separator orientation="vertical" h="40px" />
          <VStack gap={0.5}>
            {isLoading ? (
              <Skeleton height="28px" width="90px" />
            ) : data ? (
              <Text fontSize="xl" fontWeight="bold" color="teal.600">
                {formatDate(data.registeredAt)}
              </Text>
            ) : null}
            <Text fontSize="2xs" color="gray.600">
              登録日
            </Text>
          </VStack>
        </Stack>
      </VStack>
    </Card.Body>
  </Card.Root>
);

export default ProfileCard;
